module.exports = __webpack_public_path__ + "static/media/Bettdecke_140x200_Kissen_60x40.39fb0c81.png";